const AUTH_STORAGE_KEY = 'wa_cert_authenticated';
const UPDATE_VIDEOS = 'UPDATE_VIDEOS';
const UPDATE_LOADING = 'UPDATE_LOADING';
const UPDATE_ERROR = 'UPDATE_ERROR';
const SELECT_VIDEO = 'SELECT_VIDEO';
const UPDATE_QUERY_VIDEO = 'UPDATE_QUERY_VIDEO';
const ADD_TO_FAVORITES = 'ADD_TO_FAVORITES';
const REMOVE_FROM_FAVORITES = 'REMOVE_FROM_FAVORITES';
const CHANGE_MODE = 'CHANGE_MODE';
const REACT_CHALLENGE_AUTH = 'REACT_CHALLENGE_AUTH';
const REACT_CHALLENGE_FAVORITES = 'REACT_CHALLENGE_FAVORITES';

export {
  AUTH_STORAGE_KEY,
  UPDATE_VIDEOS,
  UPDATE_LOADING,
  UPDATE_ERROR,
  SELECT_VIDEO,
  UPDATE_QUERY_VIDEO,
  CHANGE_MODE,
  REACT_CHALLENGE_AUTH,
  ADD_TO_FAVORITES,
  REMOVE_FROM_FAVORITES,
  REACT_CHALLENGE_FAVORITES,
};
